var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exception',{attrs:{"title":"401 Error!","description":"抱歉，没有权限访问~","hasGoback":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }